import type { ReactNode } from 'react';

interface AppScreenProps {
  children: ReactNode;
  className?: string;
  /**
   * @deprecated Não existe mais barra de navegação inferior. Mantido só para
   * não quebrar chamadas antigas; não reserva espaço nenhum.
   */
  comBarra?: boolean;
}

// Moldura das telas do app: fundo claro e área segura. Sem barra inferior.
export default function AppScreen({ children, className = '' }: AppScreenProps) {
  return <div className={`min-h-screen bg-background-100 ${className}`}>{children}</div>;
}